module.exports = __webpack_public_path__ + "static/media/unterweisung_false_active.5457d458.jpg";